import { TypographyH2, TypographyH3, TypographyP } from '@talentmesh/ui/components/typography';
import { useAssessmentsOverviewContext } from '../../Contexts/AssessmentsOverviewContext';
import CreateRecruitmentButton from '../CreateRecruitmentButton';
import HeroIllustration from '@/Components/Animations/HeroIllustration';
import { AssessmentStatuses } from '@/Models/AssessmentData';
import UIStrings from '@/Utils/UIStrings';

const EmptyAssessmentsOverview = () => {
    const { status } = useAssessmentsOverviewContext();

    return (
        <div className="flex h-full flex-col items-center justify-center gap-4 px-4">
            {status === AssessmentStatuses.Closed ? (
                <TypographyH3 className="text-foreground text-center text-lg font-normal whitespace-pre-line">
                    {UIStrings.ThereAreNoClosedRecruitments}
                </TypographyH3>
            ) : (
                <>
                    <div className="max-w-[680px] text-center">
                        <div className="mx-auto mb-6 w-[520px] max-w-full">
                            <HeroIllustration />
                        </div>
                        <TypographyH2 className="text-foreground mb-3 text-2xl leading-8 font-semibold tracking-[-0.6px]">
                            {UIStrings.LetOurJobIntelAgentKickOffYourRecruitment}
                        </TypographyH2>
                        <TypographyP className="mx-auto mb-6 leading-6 text-slate-600">
                            {UIStrings.OurAgentCreatesYourRecruitmentByAnalyzingAndOptimizing}
                        </TypographyP>
                        <TypographyP className="mb-6 text-sm leading-5">
                            <span className="bg-[linear-gradient(transparent_calc(100%-5px),#EBF253_0)] pb-1 font-bold text-[#1E2845]">
                                {UIStrings.TakesUnderOneMinute}
                            </span>
                        </TypographyP>
                    </div>
                    <CreateRecruitmentButton />
                </>
            )}
        </div>
    );
};

export default EmptyAssessmentsOverview;
